<template>
  <section class="section user-input">
    <h2 class="section-heading">
      Wprowadź swój nick z <span class="text-accent">Faceita</span>
    </h2>
    <form v-on:submit.prevent="onSubmit" class="input-container">
      <input
        type="text"
        id="nickname"
        name="nickname"
        class="input"
        v-model="nickname"
      />
      <span class="submit-button-helper"
        ><input type="submit" class="submit-button" value="Wyślij"
      /></span>
    </form>
  </section>
</template>

<script>
export default {
  name: "Input",
  data() {
    return {
      nickname: ""
    };
  },
  methods: {
    async onSubmit() {
      if (!this.nickname) {
        this.$toast.error("Musisz wpisać nazwę gracza", {
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          hideCloseButton: false,
          hideProgressBar: false,
          icon: true
        });
      } else {
        this.$router.push(`/${this.nickname}`);
        this.$emit("render-profile", this.nickname);
        this.nickname = "";
      }
    }
  }
};
</script>
